<template>
  <StyledDiv
    width="350px"
    minWidth="33%"
    minHeight="150px"
    cursor="pointer"
    :hoverBackgroundColor="styled('lightGray')"
    @click="toggleExpand"
    maxWidth="800px"
    boxShadow="0px 0px 10px -6px black"
    borderRadius="5px"
    margin="10px"
  >
    <StyledDiv height="150px" flexDirection="row">
      <StyledText padding="0 10px">{{
        expand ? "&#8208;" : "&#43;"
      }}</StyledText>
      <StyledText :fontFamily="styled('fontFamily-GothamMedium')">{{
        info.title
      }}</StyledText>
      <StyledText padding="0 10px">{{
        expand ? "&#8208;" : "&#43;"
      }}</StyledText>
    </StyledDiv>
    <collapse-transition>
      <div v-show="expand">
        <StyledText padding="30px" textAlign="left">{{ info.desc }}</StyledText>
      </div>
    </collapse-transition>
  </StyledDiv>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";

import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  components: {
    StyledDiv,
    StyledText,
    CollapseTransition
  },
  props: ["info"],
  data() {
    return {
      expand: false
    };
  },
  methods: {
    toggleExpand() {
      this.expand = !this.expand;
    },
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style></style>
